// import { makeAsyncAction } from "../../../ui-lottery";
import {
  USER_SEARCH_ADD_ERROR,
  USER_SEARCH_CLEAR_ERROR,
//  USER_SEARCH_FETCH,
  USER_SEARCH_UPDATE
} from '../constants/actions';
import { emailField } from '../utils/asset';

// export const userSearchFetch = makeAsyncAction(USER_SEARCH_FETCH, (term) => () => api.userSearchFetch(term));
export const userSearchFetch = (term) => console.log(`userSearchFetch called: ${term}`);

export const updateUserSearchTerm = (term) => (dispatch) => dispatch({ type: USER_SEARCH_UPDATE, payload: term });

export const userSearchAddError = (error) => (dispatch) => dispatch({ type: USER_SEARCH_ADD_ERROR, payload: error });
export const userSearchClearErrors = () => (dispatch) => dispatch({ type: USER_SEARCH_CLEAR_ERROR });

export const saveUserSearchTerm = (term) => (dispatch) => {
  dispatch(userSearchClearErrors());
  dispatch(updateUserSearchTerm(term));
  const errors = emailField(term);
  if (errors && errors.length > 0) {
    dispatch(userSearchAddError(errors));
    return false;
  }
  return true;
};
